import {MyBreadcrumb, MyButton, MyModalForm, MyText} from "../../../components";
import React, {useCallback, useEffect, useMemo, useState} from "react";
import {
  Alert,
  Badge,
  Button,
  Card,
  Col,
  Collapse,
  Flex,
  Form,
  Input,
  Popconfirm,
  Row,
  Skeleton,
  Spin,
  TabsProps
} from "antd";
import {StyledInfoContainer} from "../../Plans/[ctpId]/index.styles";
import {StyledTabs} from "../../Plans/[ctpId]/[lessonId]/index.styles";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {createSearchParams, generatePath, Link, useNavigate, useParams, useSearchParams} from "react-router-dom";
import {RootState} from "../../../store";
import {selectStore} from "../../../store/selector";
import {
  FORM_SECTION_TYPES,
  FORM_SECTION_INNER_TYPE,
  FORM_FORM_TYPE,
  ROUTE_PATH
} from "../../../constants";
import {
  getGetSdotByMarkCurrent,
  getJournalTableAction,
  postJournalLessonAction, setMarkSdotType,
  setRateTaskResult
} from "../../../store/pages/journal/actions";
import {getOneLessonAction} from "../../../store/pages/plans/actions";
import {EditOutlined, PaperClipOutlined} from "@ant-design/icons";
import {getFormAction, setFormAction} from "../../../store/common/actions";
import {DefaultTokenTheme} from "../../../assets/themes/defaultTheme";
import dayjs from "dayjs";

const SEARCH_PARAMS = {
  SDOT_TYPE: 'sdotType',
  STUDENT_ID: 'studentId',

  CTP_ID: 'ctpId',
  JOURNAL_START_DATE: 'start_date',
  JOURNAL_END_DATE: 'end_date',
}

interface IInitialState {
  visible: boolean,
  item?: any
}


const FORM_NAME = {
  PLANS_TASKS_ADD: 'PLANS_TASKS_ADD',
  PLANS_TASKS_UPDATE: 'PLANS_TASKS_UPDATE',
  JOURNAL_MARK_SDOT_TYPE: 'JOURNAL_MARK_SDOT_TYPE',
}

const initialState: IInitialState = {
  visible: false,
  item: {}
}

const modalInitialState = {
  [FORM_NAME.PLANS_TASKS_ADD]: initialState,
  [FORM_NAME.PLANS_TASKS_UPDATE]: initialState,
  [FORM_NAME.JOURNAL_MARK_SDOT_TYPE]: initialState,
}

export const JournalSdot = () => {
  const {t} = useTranslation("common")

  const dispatch = useDispatch()
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  const {
    common: {ctp: ctpState, form: formState},
    plans: {lessons: lessonState, oneLesson: oneLessonState, oneCtp: oneCtpState},
    journal: {sdotResultByMarkCurrent: sdotResultByMarkCurrentState, table: tableState}
  }: RootState = useSelector(selectStore)

  const [formModalData, setFormModalData] = useState(modalInitialState)

  const [formTasksAdd] = Form.useForm()
  const [formTasksUpdate] = Form.useForm()
  const [formSdotTypeAdd] = Form.useForm()

  const sdotType = searchParams.get(SEARCH_PARAMS.SDOT_TYPE) || FORM_FORM_TYPE.MATERIALS
  const studentId = searchParams.get(SEARCH_PARAMS.STUDENT_ID)

  const ctpId = searchParams.get(SEARCH_PARAMS.CTP_ID)
  const periodStartDate = searchParams.get(SEARCH_PARAMS.JOURNAL_START_DATE)
  const periodEndDate = searchParams.get(SEARCH_PARAMS.JOURNAL_END_DATE)

  const {id: lessonId} = useParams()

  const currentStudentIndex = tableState.data?.data?.findIndex((item: any) => item.id == studentId)
  const nextStudent = tableState.data?.data?.[parseInt(currentStudentIndex) + 1]


  useEffect(() => {
    let body = {
      type: sdotType,
      lesson_id: lessonId,
      student_id: studentId,
      start_date: periodStartDate,
      end_date: periodEndDate,
    }

    dispatch(getGetSdotByMarkCurrent(body))

    dispatch(getOneLessonAction({
      lesson_id: lessonId,
      student_id: studentId
    }))

    let bodyCtp = {
      ctp_id: ctpId,
      start_date: periodStartDate,
      end_date: periodEndDate,
    }

    dispatch(getJournalTableAction(bodyCtp))
  }, [])

  const handleRateTaskResult = (item: any) => {
    console.log('item', item)

    const api = 'sdot_rate_task_result_v1'
    const section_type = FORM_SECTION_TYPES.PLANS
    const section_inner_type = FORM_FORM_TYPE.TASKS
    const form_type = FORM_SECTION_INNER_TYPE.ADD


    dispatch(getFormAction({
      api: api,
      section_type: section_type,
      section_inner_type: section_inner_type,
      form_type: form_type,
    }))


    setFormModalData(prevState => ({
      ...prevState,
      [FORM_NAME.PLANS_TASKS_ADD]: {...prevState[FORM_NAME.PLANS_TASKS_ADD], visible: true, item: item}
    }))
  }

  const handleFormModalClose = () => {
    setFormModalData(modalInitialState)
  }

  const handleModalTasksAddSave = (values: any) => {
    const main: any = formState[FORM_SECTION_TYPES.PLANS][FORM_FORM_TYPE.TASKS][FORM_SECTION_INNER_TYPE.ADD].data[0]
    const state: any = formModalData[FORM_NAME.PLANS_TASKS_ADD]

    let body = {
      ...values,
      task_result_id: state?.item?.id,
      lesson_id: lessonId,
      student_id: studentId,
      type: sdotType,
      start_date: periodStartDate,
      end_date: periodEndDate,
    }

    dispatch(setFormAction({
      method: main?.method,
      path: main?.action,
      fields: body,
      action: setRateTaskResult
    }))

    setFormModalData(modalInitialState)
  }

  const handleModalTasksUpdateSave = (values: any) => {
    const main: any = formState[FORM_SECTION_TYPES.PLANS][FORM_FORM_TYPE.TASKS][FORM_SECTION_INNER_TYPE.UPDATE].data[0]
    const state: any = formModalData[FORM_NAME.PLANS_TASKS_UPDATE]

    let body = {
      ...values,
      task_result_id: state?.item?.resultByStudent?.id,
      lesson_id: lessonId,
      student_id: studentId,
      type: sdotType,
      start_date: periodStartDate,
      end_date: periodEndDate,
    }

    dispatch(setFormAction({
      method: main?.method,
      path: main?.action,
      fields: body,
      action: setRateTaskResult
    }))

    setFormModalData(modalInitialState)
  }

  const renderTaskComponent = (file: any, index: any) => {
    return (
      <Row gutter={[16, 16]} align='middle' key={index}>
        <Col>
          <Flex justify='center' align='center' style={{
            width: 48,
            height: 48,
            borderRadius: 8,
            background: '#F2F2F7'
          }}>
            <PaperClipOutlined style={{fontSize: 20}}/>
          </Flex>
        </Col>
        <Col span={20}>
          <Row gutter={[8, 8]} align='middle'>
            <Col span={24}>
              <MyText color='#8E8E8E' size={12} weight={500}>
                Файл
              </MyText>
            </Col>
            <Col span={24}>
              <Link to={file}>
                <MyText color={DefaultTokenTheme.link}>
                  {file.split('/')?.[file.split('/')?.length - 1]}
                </MyText>
              </Link>
            </Col>
          </Row>
        </Col>
      </Row>
    )
  }

  const stateContent = (current: any) => {
    switch (current?.resultByStudent?.state) {
      case 0:
        return (
          <Alert message="Не выполнено" type="error" showIcon/>
        )
      case 5:
        return (
          <Alert message="На проверке" type="warning" showIcon/>
        )
      case 6:
        return (
          <Alert message="Проверено" type="success" showIcon/>
        )

      default:
        return (
          <MyButton onClick={() => handleRateTaskResult(current?.resultByStudent)}>
            {current?.resultByStudent?.state} Оценить
          </MyButton>
        )
    }
  }

  const handleTestView = (item: any) => {
    const path = {
      // @ts-ignore
      pathname: generatePath(ROUTE_PATH.JOURNAL_SDOT_TEST_VIEW, {testId: item.id, id: lessonId}),
      // @ts-ignore
      search: createSearchParams({
        sdotType: sdotType,
        studentId: studentId,
        ctpId: ctpId,
        start_date: periodStartDate,
        end_date: periodEndDate,
      }).toString(),
    }
    navigate(path)
  }

  const handleUpdateTaskStatus = (item: any) => {
    console.log('item', item)

    const api = item?.resultByStudent?.form
    const section_type = FORM_SECTION_TYPES.PLANS
    const section_inner_type = FORM_FORM_TYPE.TASKS
    const form_type = FORM_SECTION_INNER_TYPE.UPDATE


    dispatch(getFormAction({
      api: api,
      section_type: section_type,
      section_inner_type: section_inner_type,
      form_type: form_type,
    }))


    setFormModalData(prevState => ({
      ...prevState,
      [FORM_NAME.PLANS_TASKS_UPDATE]: {...prevState[FORM_NAME.PLANS_TASKS_UPDATE], visible: true, item: item}
    }))
  }

  const materialAlertType = {
    0: 'error',
    1: 'success'
  }

  const renderInnerItem = (item: any) => {
    return (
      <Row align='middle' gutter={6}>
        <Col span={7}>
          <MyText color={'var(--c-subtitle)'} weight={500}>
            {item.label}:
          </MyText>
        </Col>

        <Col span={17}>
          <MyText>
            <div dangerouslySetInnerHTML={{ __html: item?.value }} />
          </MyText>
        </Col>
      </Row>
    )
  }

  const innerRenderCurrentTab = useMemo(() => {
    switch (sdotType) {
      case FORM_FORM_TYPE.MATERIALS:
        return (
          <Row>
            {
              sdotResultByMarkCurrentState.data?.map((current: any) => (
                <Col span={24} key={current.id}>
                  <Card style={{margin: 10}} bodyStyle={{padding: 12}} loading={sdotResultByMarkCurrentState.loading}>
                    <Row gutter={[16, 16]} align='top'>
                      <Col span={24}>
                        <MyText color='rgba(28, 28, 30, 1)' weight={500} size={20}>
                          {current.name}
                        </MyText>
                      </Col>

                      <Col span={20}>
                        <Row gutter={[8, 8]}>
                          {
                            current?.view?.map((inner: any, index: any) => (
                              <Col key={index} span={24}>
                                {renderInnerItem(inner)}
                              </Col>
                            ))
                          }
                        </Row>
                      </Col>

                      {
                        current?.resultByStudent &&
                        <Col span={4}>
                          {/*// @ts-ignore*/}
                          <Alert message={current?.resultByStudent?.stateLabel} type={materialAlertType[current?.resultByStudent?.state]} showIcon/>
                        </Col>
                      }
                    </Row>
                  </Card>
                </Col>
              ))
            }
          </Row>
        )
      case FORM_FORM_TYPE.TASKS:
        return (
          <Row>
            {
              sdotResultByMarkCurrentState.data?.map((current: any) => (
                <Col span={24} key={current.id}>
                  <Card style={{margin: 10}} bodyStyle={{padding: 12}} loading={sdotResultByMarkCurrentState.loading}>
                    <Row gutter={[16, 16]}>
                      <Col span={24}>
                        <MyText color='rgba(28, 28, 30, 1)' weight={500} size={20}>
                          {current.name}
                        </MyText>
                      </Col>

                      <Col span={24}>
                        <Row gutter={[8, 8]}>
                          {
                            current?.view?.map((inner: any, index: any) => (
                              <Col key={index} span={24}>
                                {renderInnerItem(inner)}
                              </Col>
                            ))
                          }
                        </Row>
                      </Col>

                      {
                        current?.resultByStudent?.id &&
                        <Col span={24}>
                          <Card bodyStyle={{padding: 12, background: '#FAFAFA'}}>
                            <Row gutter={[10, 10]} justify='space-between' align='middle'>
                              <Col span={20}>
                                <Row gutter={[10, 10]}>
                                  <Col span={24}>
                                    <MyText size={20} weight={500} color='rgba(28, 28, 30, 1)'>
                                      Ответ
                                    </MyText>
                                  </Col>

                                  {
                                    current?.resultByStudent?.answer &&
                                    <Col span={24}>
                                      <MyText>
                                        {current?.resultByStudent?.answer}
                                      </MyText>
                                    </Col>
                                  }

                                  {
                                    current?.resultByStudent?.files &&
                                    <Col span={24}>
                                      {
                                        Array.isArray(current?.resultByStudent?.files) ? current?.resultByStudent?.files?.map((file: any, index: any) => (
                                            file && renderTaskComponent(file, index)
                                          ))
                                          : renderTaskComponent(current?.resultByStudent?.files, 'indexFileResultByStudent')
                                      }
                                    </Col>
                                  }
                                </Row>
                              </Col>

                              {
                                current?.resultByStudent?.id &&
                                <Col span={4}>
                                  <Row justify='space-between' align='middle'>
                                    <Col>
                                      {stateContent(current)}
                                    </Col>

                                    <Col>
                                      <MyButton type='text' icon={<EditOutlined/>} onClick={() => handleUpdateTaskStatus(current)}/>
                                    </Col>
                                  </Row>
                                </Col>
                              }

                            </Row>
                          </Card>
                        </Col>
                      }

                    </Row>

                  </Card>
                </Col>
              ))
            }
          </Row>
        )
      case FORM_FORM_TYPE.TESTS:
        return (
          <Row>
            {
              sdotResultByMarkCurrentState.data?.map((current: any) => (
                <Col span={24} key={current.id}>
                  <Card style={{margin: 10}} bodyStyle={{padding: 12}} loading={sdotResultByMarkCurrentState.loading}>
                    <Row gutter={[16, 16]}>
                      <Col span={24}>
                        <MyText color='rgba(28, 28, 30, 1)' weight={500} size={20}>
                          {current.name}
                        </MyText>
                      </Col>

                      <Col span={24}>
                        <Row gutter={[8, 8]}>
                          {
                            current?.view?.map((inner: any, index: any) => (
                              <Col key={index} span={24}>
                                {renderInnerItem(inner)}
                              </Col>
                            ))
                          }
                        </Row>
                      </Col>


                      {
                        current?.resultByStudent &&
                        <Col span={24}>
                          <Card bodyStyle={{padding: 12, background: '#FAFAFA'}}>
                            <Row gutter={[10, 10]} justify='space-between' align='middle'>
                              <Col span={20}>
                                <Row gutter={[10, 10]} justify='space-between' align='middle'>
                                  <Col span={24}>
                                    <MyText size={20} weight={500} color='rgba(28, 28, 30, 1)'>
                                      Результаты тестирования
                                    </MyText>
                                  </Col>

                                  <Col span={24}>
                                    <Row gutter={[10, 10]}>
                                      {
                                        current?.resultByStudent?.finished ?
                                          <Col span={12}>
                                            <MyText>
                                              Дата
                                              прохождения: {dayjs(current?.resultByStudent?.finished).format('DD.MM.YYYY HH:mm:ss')}
                                            </MyText>
                                          </Col> : null
                                      }

                                      {
                                        current?.resultByStudent?.correct_answers ?
                                          <Col span={12}>
                                            <MyText>
                                              Количество правильных: {current?.resultByStudent?.correct_answers}
                                            </MyText>
                                          </Col> : null
                                      }
                                      {
                                        current?.resultByStudent?.result ?
                                          <Col span={12}>
                                            <MyText>
                                              Результат: {current?.resultByStudent?.result}
                                            </MyText>
                                          </Col> : null
                                      }

                                    </Row>
                                  </Col>
                                </Row>
                              </Col>

                              <Col>
                                <MyButton onClick={() => handleTestView(current)}>
                                  Посмотреть
                                </MyButton>
                              </Col>
                            </Row>
                          </Card>
                        </Col>
                      }
                    </Row>

                  </Card>
                </Col>
              ))
            }
          </Row>
        )

      default:
        return false
    }
  }, [sdotResultByMarkCurrentState, sdotType])

  const tabItems: TabsProps["items"] = [
    {
      key: FORM_FORM_TYPE.MATERIALS,
      label: t('materials'),
      children: innerRenderCurrentTab
    },
    {
      key: FORM_FORM_TYPE.TASKS,
      label: t('tasks'),
      children: innerRenderCurrentTab
    },
    {
      key: FORM_FORM_TYPE.TESTS,
      label: t('tests'),
      children: innerRenderCurrentTab
    },
  ]

  const handleTabChange = (key: any) => {
    // @ts-ignore
    setSearchParams({
      [SEARCH_PARAMS.SDOT_TYPE]: key,
      studentId: studentId,
      ctpId: ctpId,
      start_date: periodStartDate,
      end_date: periodEndDate,
    })

    let body = {
      type: key,
      lesson_id: lessonId,
      student_id: studentId,
      start_date: periodStartDate,
      end_date: periodEndDate,
    }

    dispatch(getGetSdotByMarkCurrent(body))
  }

  const handleClickNextStudent = () => {
    // @ts-ignore
    setSearchParams({
      sdotType: sdotType,
      studentId: nextStudent?.id,
      ctpId: ctpId,
      start_date: periodStartDate,
      end_date: periodEndDate,
    })

    let body = {
      type: sdotType,
      lesson_id: lessonId,
      student_id: nextStudent?.id,
      start_date: periodStartDate,
      end_date: periodEndDate,
    }

    dispatch(getGetSdotByMarkCurrent(body))

    dispatch(getOneLessonAction({
      lesson_id: lessonId,
      student_id: nextStudent?.id
    }))
  }

  const backLink = `/journal/${ctpId}`

  const markPlanFormTypesLabel = {
    [FORM_FORM_TYPE.TASKS]: 'Оценивание задания',
    [FORM_FORM_TYPE.TESTS]: 'Оценивание теста',
  }

  let currentPlanFormSdotTypes = {
    [FORM_FORM_TYPE.MATERIALS]: oneLessonState.data?.['materials-grade'],
    [FORM_FORM_TYPE.TASKS]: oneLessonState.data?.['tasks-grade'],
    [FORM_FORM_TYPE.TESTS]: oneLessonState.data?.['tests-grade'],
  }

  const handleEditMarkSdotType = () => {
    let section_type = FORM_SECTION_TYPES.JOURNAL
    let section_inner_type = sdotType
    let form_type = FORM_SECTION_INNER_TYPE.UPDATE

    dispatch(getFormAction({
      api: currentPlanFormSdotTypes[sdotType]?.form,
      section_type: section_type,
      section_inner_type: section_inner_type,
      form_type: form_type
    }))

    setFormModalData(prevState => ({
      ...prevState,
      [FORM_NAME.JOURNAL_MARK_SDOT_TYPE]: {...prevState[FORM_NAME.JOURNAL_MARK_SDOT_TYPE], visible: true, item: currentPlanFormSdotTypes?.[sdotType]}
    }))

    if(currentPlanFormSdotTypes?.[sdotType]?.percent){
      formSdotTypeAdd.setFields([
        {
          name: 'percent',
          value: currentPlanFormSdotTypes?.[sdotType]?.percent
        }
      ])
    }
  }

  const handleModalJournalMarkSdotTypeSave = (values: any) => {
    const main: any = formState[FORM_SECTION_TYPES.JOURNAL][sdotType][FORM_SECTION_INNER_TYPE.UPDATE].data[0]
    const state: any = formModalData[FORM_NAME.JOURNAL_MARK_SDOT_TYPE]

    let type = {
      [FORM_FORM_TYPE.MATERIALS]: 1,
      [FORM_FORM_TYPE.TASKS]: 2,
      [FORM_FORM_TYPE.TESTS]: 3,
    }

    let body = {
      ...values,
      student_id: studentId,
      lesson_id: lessonId,
      type: type[sdotType]
    }

    dispatch(setFormAction({
      method: main?.method,
      path: main?.method === 'POST' ? main?.action : `${main?.action}/${state?.item?.id}`,
      fields: body,
      action: setMarkSdotType
    }))

    setFormModalData(modalInitialState)
  }

  return (
    <>
      <MyBreadcrumb title={tableState.data?.data?.[currentStudentIndex]?.fio}
                    link={backLink} isBack
                    extra={nextStudent && (
                      <MyButton height={40} type="text"
                                title={`Перейти к следующему: ${nextStudent?.fio}`} onClick={handleClickNextStudent}/>
                    )}/>

      <Row justify='center'>
        <Col span={20}>
          <StyledInfoContainer>
            <Spin spinning={oneLessonState.loading}>
              <Row style={{borderBottom: '1px solid #E8E8E8', padding: 24}}>
                <Col>
                  <h1>{oneLessonState.data?.header}</h1>
                </Col>
              </Row>
              <Row gutter={[16, 16]} style={{padding: 24}}>
                {
                  oneLessonState.data?.view?.filter((item: any) => item.template !== 'accordion')?.map((item: any) => (
                    item.value &&
                    <Col span={12} key={item.label}>
                      <MyText>
                        {item.label} : {item.value}
                      </MyText>
                    </Col>
                  ))
                }
              </Row>
            </Spin>
          </StyledInfoContainer>

          <StyledInfoContainer>
            <Spin spinning={sdotResultByMarkCurrentState.loading}>
              <StyledTabs activeKey={sdotType} items={tabItems} onChange={handleTabChange}/>
            </Spin>
          </StyledInfoContainer>

          {
            sdotResultByMarkCurrentState?.data?.length > 0 &&

            markPlanFormTypesLabel[sdotType] &&

            <StyledInfoContainer>
              <Card loading={oneLessonState.loading || sdotResultByMarkCurrentState.loading}>
                <Row gutter={[16, 16]}>
                  <Col span={24}>
                    <MyText size={18} weight={500}>
                      {markPlanFormTypesLabel[sdotType]}
                    </MyText>
                  </Col>

                  <Col span={24}>
                    <Row gutter={16} align='middle'>
                      <Col>
                        <MyText weight={500} size={18}>
                          {currentPlanFormSdotTypes?.[sdotType]?.percent}
                        </MyText>
                      </Col>
                      <Col>
                        <MyButton onClick={handleEditMarkSdotType} height={40}>
                          Изменить
                        </MyButton>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Card>
            </StyledInfoContainer>
          }

        </Col>
      </Row>

      <MyModalForm
        formName={FORM_NAME.PLANS_TASKS_ADD}
        form={formTasksAdd}
        title={formState[FORM_SECTION_TYPES.PLANS]?.[FORM_FORM_TYPE.TASKS]?.[FORM_SECTION_INNER_TYPE.ADD]?.data[0]?.title}
        visible={formModalData[FORM_NAME.PLANS_TASKS_ADD].visible}
        state={formState[FORM_SECTION_TYPES.PLANS]?.[FORM_FORM_TYPE.TASKS]?.[FORM_SECTION_INNER_TYPE.ADD]}
        onCancel={handleFormModalClose}
        onFinish={handleModalTasksAddSave}
        period={{
          // @ts-ignore
          start_date: periodStartDate,
          // @ts-ignore
          end_date: periodEndDate,
        }}
      />

      <MyModalForm
        formName={FORM_NAME.PLANS_TASKS_UPDATE}
        form={formTasksUpdate}
        title={formState[FORM_SECTION_TYPES.PLANS]?.[FORM_FORM_TYPE.TASKS]?.[FORM_SECTION_INNER_TYPE.UPDATE]?.data[0]?.title}
        visible={formModalData[FORM_NAME.PLANS_TASKS_UPDATE].visible}
        state={formState[FORM_SECTION_TYPES.PLANS]?.[FORM_FORM_TYPE.TASKS]?.[FORM_SECTION_INNER_TYPE.UPDATE]}
        onCancel={handleFormModalClose}
        onFinish={handleModalTasksUpdateSave}
        period={{
          // @ts-ignore
          start_date: periodStartDate,
          // @ts-ignore
          end_date: periodEndDate,
        }}
      />

      <MyModalForm
        formName={FORM_NAME.JOURNAL_MARK_SDOT_TYPE}
        form={formSdotTypeAdd}
        title={formState[FORM_SECTION_TYPES.JOURNAL]?.[sdotType]?.[FORM_SECTION_INNER_TYPE.UPDATE]?.data[0]?.title}
        visible={formModalData[FORM_NAME.JOURNAL_MARK_SDOT_TYPE].visible}
        state={formState[FORM_SECTION_TYPES.JOURNAL]?.[sdotType]?.[FORM_SECTION_INNER_TYPE.UPDATE]}
        onCancel={handleFormModalClose}
        onFinish={handleModalJournalMarkSdotTypeSave}
        period={{
          // @ts-ignore
          start_date: periodStartDate,
          // @ts-ignore
          end_date: periodEndDate,
        }}
      />
    </>
  )
}